import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const STORAGE_KEY = 'pwa_page_view_count';

/**
 * Tracks page views within a session for install banner timing.
 * Uses sessionStorage — resets when tab closes.
 */
export default function usePageViewCount() {
  const location = useLocation();
  const [pageViewCount, setPageViewCount] = useState(() => {
    return parseInt(sessionStorage.getItem(STORAGE_KEY) || '0', 10);
  });

  useEffect(() => {
    const newCount = pageViewCount + 1;
    sessionStorage.setItem(STORAGE_KEY, String(newCount));
    setPageViewCount(newCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return { pageViewCount };
}
